import React, { useState, useEffect, useCallback } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    TextField,
    Typography,
    MenuItem,
    Alert,
    OutlinedInput,
    InputAdornment,
    Paper,
    List,
    ListItem,
    ListItemButton
} from '@mui/material';
import { IconSearch } from '@tabler/icons';
import debounce from 'lodash.debounce';
import { useParams, useHistory } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import api from '../../../../services/api';

const EditUserSystem = ({ user_id, onClose }) => {
    // const { id } = useParams();

    console.log('EditUserSystem recebeu user_id:', user_id);
    const history = useHistory();

    const [appId, setAppId] = useState(null);
    const [loading, setLoading] = useState(true);

    const [formData, setFormData] = useState({
        email: '',
        first_name: '',
        last_name: '',
        username: '',
        role: '',
        organization: null,
        organization_name: '',
        phone: '',
        avatar: ''
    });

    const [dadosUser, setDadosUser] = useState({});
    const [status, setStatus] = useState({ type: '', message: '' });

    //  busca organization
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [showResults, setShowResults] = useState(false);

    //  pegar app padrão
    const pegar_app_padrao = async () => {
        try {
            const response = await api.get('v1/apps/default/');
            setAppId(response.data.app.id);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        pegar_app_padrao();
    }, []);

    //  só busca user quando tiver appId
    useEffect(() => {
        if (!appId) return;
        fetchUser();
    }, [appId, user_id]);

    const fetchUser = async () => {
        try {
            console.log(`Buscando usuário com ID ${user_id} para o app ${appId}`);
            const response = await api.get(`users/${user_id}/`);
            setFormData(response.data);
            setLoading(false);
            setDadosUser(response.data);
        } catch (error) {
            console.error('Erro ao buscar usuario:', error);
            setLoading(false);
            setStatus({ type: 'error', message: 'Erro ao buscar usuário' });
        }
    };

    const backPage = () => {
        // history.push(`/dashboard/config/index/`);
        onClose();
    };

    //  update form
    const handleChange = (e) => {
        const { name, value } = e.target;

        const newData = {
            ...formData,
            [name]: value
        };

        if (name === 'first_name' || name === 'last_name') {
            const fn = name === 'first_name' ? value : formData.first_name;
            const ln = name === 'last_name' ? value : formData.last_name;

            if (fn && ln) {
                newData.username = `${fn.toLowerCase()}.${ln.toLowerCase()}`;
            }
        }

        setFormData(newData);
    };

    // busca organization com appId
    const handleSearch = useCallback(
        debounce(async (value, currentAppId) => {
            if (!value || !currentAppId) {
                setSearchResults([]);
                setShowResults(false);
                return;
            }

            try {
                const response = await api.get(`v1/apps/${currentAppId}/organizations/?search=${encodeURIComponent(value)}`);

                setSearchResults(response.data.organizations || response.data);
                setShowResults(true);
            } catch (error) {
                console.error('Erro na busca:', error);
                setStatus({ type: 'error', message: 'Erro ao buscar organizações' });
            }
        }, 400),
        []
    );

    const handleChangeSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        if (!appId) return;

        handleSearch(value, appId);
    };

    const handleSelectOrganization = (org) => {
        setFormData({
            ...formData,
            organization: org.id,
            organization_name: org.name
        });

        setSearchTerm(org.name);
        setShowResults(false);
    };

    const clearOrganization = () => {
        setFormData({
            ...formData,
            organization: null,
            organization_name: ''
        });

        setSearchTerm('');
        setShowResults(false);
    };

    const handleDeleteUser = async () => {
        try {
            await api.delete(`users/${user_id}/`);
            setStatus({ type: 'success', message: 'Usuário apagado com sucesso!' });
            backPage();
        } catch (error) {
            setStatus({
                type: 'error',
                message: error.response?.data?.detail || 'Erro ao apagar usuário.'
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ type: '', message: '' });

        try {
            await api.put(`users/${user_id}/`, formData);

            setStatus({ type: 'success', message: 'Usuário editado com sucesso!' });
            // backPage();
        } catch (error) {
            setStatus({
                type: 'error',
                message: error.response?.data?.detail || 'Erro ao editar usuário.'
            });
        }
    };

    if (loading) return <Typography>Carregando...</Typography>;

    return (
        <Box>
            <Typography variant="h5" gutterBottom sx={{ mb: 2, mt: 2, ml: 1 }}>
                Editar Usuário
            </Typography>

            {status.message && (
                <Alert severity={status.type} sx={{ mb: 2 }}>
                    {status.message}
                </Alert>
            )}

            <Card>
                <CardContent>
                    {status.message && (
                        <Alert severity={status.type} sx={{ mb: 2 }}>
                            {status.message}
                        </Alert>
                    )}

                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            {/* Nomes */}
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    name="first_name"
                                    label="Primeiro Nome"
                                    fullWidth
                                    value={formData.first_name}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    name="last_name"
                                    label="Segundo Nome"
                                    fullWidth
                                    value={formData.last_name}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>

                            {/* Username gerado automaticamente */}
                            <Grid item xs={12}>
                                <TextField name="username" label="Username" fullWidth value={formData.username} disabled />
                            </Grid>

                            {/* Email */}
                            <Grid item xs={12} sm={6}>
                                <TextField name="email" label="Email" fullWidth value={formData.email} onChange={handleChange} required />
                            </Grid>

                            {dadosUser.role === 'admin' && (
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        name="role"
                                        select
                                        label="Nível de Permissão"
                                        fullWidth
                                        value={formData.role}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value="admin">Administrador</MenuItem>
                                        <MenuItem value="agent">Membro da Empresa</MenuItem>
                                        <MenuItem value="customer">Usuário Final</MenuItem>
                                    </TextField>
                                </Grid>
                            )}
                            {(dadosUser.role === 'agent' || dadosUser.role === 'customer') && (
                                <Grid item xs={12} sm={6}>
                                    <TextField name="role" label="Nível de Permissão" fullWidth value={formData.role}>
                                        <MenuItem value="admin">Administrador</MenuItem>
                                        <MenuItem value="agent">Membro da Empresa</MenuItem>
                                        <MenuItem value="customer">Usuário Final</MenuItem>
                                    </TextField>
                                </Grid>
                            )}

                            {/* Campo de busca da Organização */}
                            <Grid item xs={12}>
                                <OutlinedInput
                                    fullWidth
                                    placeholder="Buscar organização por nome, CNPJ ou CPF..."
                                    value={searchTerm}
                                    onChange={handleChangeSearch}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <IconSearch size="1.2rem" color="#666" />
                                        </InputAdornment>
                                    }
                                />
                            </Grid>

                            {/* Lista de resultados */}
                            {showResults && (
                                <Grid item xs={12}>
                                    <Paper elevation={3}>
                                        <List>
                                            {searchResults.length === 0 && <ListItem>Nenhuma organização encontrada</ListItem>}

                                            {searchResults.map((org) => (
                                                <ListItem disablePadding key={org.id}>
                                                    <ListItemButton onClick={() => handleSelectOrganization(org)}>
                                                        {org.name}
                                                    </ListItemButton>
                                                </ListItem>
                                            ))}

                                            {/* opção de deixar sem organização */}
                                            <ListItem disablePadding>
                                                <ListItemButton onClick={clearOrganization}>Sem organização</ListItemButton>
                                            </ListItem>
                                        </List>
                                    </Paper>
                                </Grid>
                            )}

                            {/* Telefone */}
                            <Grid item xs={12} sm={6}>
                                <TextField name="phone" label="Telefone" fullWidth value={formData.phone} onChange={handleChange} />
                            </Grid>

                            {/* Avatar */}
                            <Grid item xs={12} sm={6}>
                                <TextField name="avatar" label="Avatar (URL)" fullWidth value={formData.avatar} onChange={handleChange} />
                            </Grid>

                            {/* Botões */}
                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="flex-end" gap={2}>
                                    <Button variant="outlined" color="secondary" onClick={backPage}>
                                        Voltar
                                    </Button>

                                    <Button type="submit" variant="contained" sx={{ backgroundColor: '#32CD32' }}>
                                        Salvar
                                    </Button>

                                    {dadosUser.role === 'admin' && (
                                        <Button variant="contained" onClick={handleDeleteUser} sx={{ backgroundColor: '#a84032' }}>
                                            Apagar
                                        </Button>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </Box>
    );
};

export default EditUserSystem;
